// @flow
import React, { PureComponent } from 'react';
import SelectPreferredNumbers from './SelectPreferredNumbers.container';
import { FullScreenModal } from '../../../../../components/common';

export default class SelectPreferredNumbersModal extends PureComponent<Props> {
  render() {
    return (
      <FullScreenModal {...this.props}>
        <SelectPreferredNumbers onRequestClose={this.props.onRequestClose} />
      </FullScreenModal>
    );
  }
}

type Props = {
  visible: boolean,
  onRequestClose: () => void,
};
